import { Config } from "../../configs/shared/config.model";
import { Role } from "./role.model";

export class Owner {
  public config: Config;
  public designerID: string;
  public designerRespondentID: number;
  public email: string;
  public externalConfigID: number;
  public externalID: number;
  public externalSearchable: boolean = false;
  public externalSourceTable: string;
  public externalVisible: boolean = false;
  public hideUniversal: boolean = false;
  public id: number;
  public login: string;
  public name: string;
  public notes: string;
  public ownerID: number;
  public retentionPolicyID: number;
  public role: Role;
  public roleID: number;
  public selected: boolean;
  public system: string;
  public maintenance: boolean;
  public maintenanceHtml: string;
}
